<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import { showError } from "../../Utils/utilFunctions.svelte";
    import {
        PageHead,
        PageLoading,
    } from "../../Components/Common/index.svelte";
    import ExternalGroupDetails from "../../Pages/ExternalGroups/components/ExternalGroupDetails.svelte";
    import ExternalGroupInvoices from "../../Pages/ExternalGroups/components/ExternalGroupInvoices.svelte";

    export let params;

    let isLoadingExternalGroupDetails = false,
        groupDetails = {},
        groupInvoices = [];

    onMount(() => {
        if (params.id) getExternalGroupDetails();
    });

    const getExternalGroupDetails = async () => {
        isLoadingExternalGroupDetails = true;

        await loadGroupDetails();

        await loadGroupInvoices();

        isLoadingExternalGroupDetails = false;
    };

    const loadGroupDetails = async () => {
        await apiMethods.getMethod
            .getExternalGroupById(params.id)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to load external group details, please refresh the page and try again and contact support if the issue persists.",
                    );
                else groupDetails = { ...res };
            })
            .catch((err) => showError(err));
    };

    const loadGroupInvoices = async () => {
        await apiMethods.getMethod
            .getExternalGroupInvoices(0, 999999, {
                "filter[groupId]": params.id,
            })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to load group invoices, please refresh the page and try again and contact support if the issue persists.",
                    );
                else groupInvoices = [...res.results];
            })
            .catch((err) => showError(err));
    };
</script>

<PageHead title="View External Group Details" />

{#if isLoadingExternalGroupDetails}
    <PageLoading />
{:else}
    <div class="flex-1 relative mt-4">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 px-2">
            <ExternalGroupDetails {groupDetails} />

            <ExternalGroupInvoices {groupInvoices} />
        </div>
    </div>
{/if}
